import React from 'react';
import { Product } from './ProductGrid';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../stores/types';
import { addToCart, removeFromCart } from '../../../stores/slices/CartSlice';
import { formatXAF } from '../../../utils/currency';
import ViewModal from './ViewModal';

interface DetailPanelProps {
  product: Product | null;
  onClose: () => void;
  isInCart: boolean;
  onToggleCart: (id: number) => void;
}

const DetailPanel: React.FC<DetailPanelProps> = ({ product, onClose, isInCart, onToggleCart }) => {

  const dispatch = useDispatch();

  if (!product) return null; // Si pas de produit, on ne rend rien

  return (
    <div className={`detail-panel ${product ? 'open' : ''}`} id="detail-panel">
      {/* Bouton de fermeture */}
      <button className="detail-close" onClick={onClose}>×</button>

      <div id="detail-content">
        <span className={`detail-badge ${product.badge}`}>
          {product.type === 'materiel' && 'Matériel'}
          {product.type === 'service' && 'Service'}
          {product.type === 'cloud' && 'Cloud'}
          {product.type === 'licence' && 'Licence'}
          {product.type === 'pack' && 'Pack'}
        </span>
        
        <div className="detail-name">{product.name}</div>
        <div className="detail-tagline">{product.tagline}</div>

        {/* Bloc Prix / Devis */}
        {product.devis ? (
          <div className="devis-info">Prix sur devis — contactez-nous</div>
        ) : (
          <div className="detail-price-block">
            <div className="detail-price">
                {formatXAF(product.price)}
                {/* {product.price} FCFA */}
            </div>
            {product.unit && <div className="detail-unit">{product.unit}</div>}
          </div>
        )}

        {/* Section Description */}
        <div className="detail-section">Description</div>
        <div className="detail-desc">{product.description}</div>

        {/* Liste dynamique (Features) */}
        <div className="detail-section">Ce qui est inclus</div>
        <ul className="detail-features">
          {product.features.map((feat, index) => (
            <li key={index}>
              <div className="feat-dot"></div>
              <span>{feat}</span>
            </li>
          ))}
        </ul>
        <ViewModal
            image={typeof product.image === 'string' ? product.image : undefined}
            images={Array.isArray(product.image) ? product.image : undefined}
            alternativeText={product.name}
            imageTitle={product.name}
        />
        {/* Actions */}
        <button 
          className={`detail-add ${isInCart ? 'added' : ''}`}
          onClick={() => {
            onToggleCart(product.id)
            dispatch(isInCart ? removeFromCart({ id: product.id, price: product.price }) : addToCart({ id: product.id, price: product.price }));
            }
          }
        >
          {isInCart ? 'Dans le devis — retirer' : '+ Ajouter au devis'}
        </button>

        {/* Liens de contact dynamiques */}
        <a 
          href={`https://wa.me/237696427703?text=${encodeURIComponent('Infos sur : ' + product.name)}`}
          target="_blank"
          className="contact-link whatsapp"
        >
          WhatsApp — Demander des infos
        </a>
      </div>
    </div>
  );
};

export default DetailPanel;